import * as styles from "./TabsTab.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Tabs as BaseTabs } from "@base-ui/react/tabs";
import { Icon } from "@frontend/components/atoms/Icon";

import { useTabsContext } from "./Tabs.context";
import type { TabsTabProps } from "./Tabs.types";

export function TabsTab({
  className,
  icon,
  children,
  ...props
}: TabsTabProps): JSX.Element {
  const { size, variant, orientation } = useTabsContext();

  return (
    <BaseTabs.Tab
      data-slot="tabs-tab"
      className={clsx(styles.tab({ size, variant, orientation }), className)}
      {...props}
    >
      {icon ? <Icon name={icon} /> : null}
      {children}
    </BaseTabs.Tab>
  );
}
